import React, {Component} from 'react';
import {getGameTitle} from '../../../../../helpers/eventHelpers';
import {getText} from '../../../../../helpers/localization';
import OpenBet from '../../../components/openBet';
import { toSentenceCase } from '../helpers/marketHelpers';
class OpenBetBaseball extends Component {

    render() {
        let playerOneFullName = this.props.betSelection.bets[0].event.playerOne;
        let playerTwoFullName = this.props.betSelection.bets[0].event.playerTwo;
        let playerOne = playerOneFullName.split(" ").length>2?playerOneFullName.split(" ")[2]:playerOneFullName.split(" ")[1];
        let playerTwo = playerTwoFullName.split(" ").length>2?playerTwoFullName.split(" ")[2]:playerTwoFullName.split(" ")[1];;
        let betSelection = this.props.betSelection;
        let betType = toSentenceCase(getText(this.props.betSelection.bets[0].betType.name, this.props.store, [playerOne, playerTwo]));

        let name;
            if (
              betSelection.bets[0].market.code === 243 ||
              betSelection.bets[0].market.code === 246
            ) {
              name = betSelection.bets[0].market.selection;
            } else if (
              betSelection.bets[0].market.code === 244 ||
              betSelection.bets[0].market.code === 250 ||
              betSelection.bets[0].market.code === 251
            ) {
              name =
                toSentenceCase(getText(
                  betSelection.bets[0].market.selection.split("_")[0],
                  this.props.store
                )) +
                " " +
                betSelection.bets[0].market.selection.split("_")[1] +
                "." +
                betSelection.bets[0].market.selection.split("_")[2];
            } else if (betSelection.bets[0].market.code === 245) {
              name = betSelection.bets[0].market.selection.replace(
                " Home Runs",
                ""
              );
            } else if (betSelection.bets[0].market.code === 247) {
              betType = getText(this.props.betSelection.bets[0].betType.name+"_SHORT",this.props.store)
              switch (betSelection.bets[0].market.id) {
                case "247_1":
                case "247_2":
                  name = getText(
                    betSelection.bets[0].market.selection,
                    this.props.store,
                    [toSentenceCase(playerOne)]
                  );
                  break;
                case "247_3":
                case "247_4":
                  name = getText(
                    betSelection.bets[0].market.selection,
                    this.props.store,
                    [toSentenceCase(playerTwo)]
                  );
                  break;
                default:
                  name = getText(
                    betSelection.bets[0].market.selection,
                    this.props.store
                  );
                  break;
              }
            } else {
              name = betSelection.bets[0].market.selection;
            }
         
       



        let names = [name];

        let title = `${toSentenceCase(playerOne)} ${getText('VS', this.props.store)} ${toSentenceCase(playerTwo)}`;
        let eventName = getGameTitle(title, this.props.betSelection.bets[0].event.eventTimeDate, this.props.store.getState().vpp.systemLanguage);
        let odd = this.props.betSelection.bets[0].market.odds;

        return (
            <OpenBet
                store={this.props.store}
                index={this.props.index}
                betSelection={this.props.betSelection}
                names={names}
                betType={betType}
                odd={odd}
                eventName={eventName}
                isEnabled={this.props.isEnabled}
                openBetFocusCallback={this.props.openBetFocusCallback}/>
        );
    }
}

export default OpenBetBaseball;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/baseball/components/openBetBaseball.js